import React from 'react';
import Form from 'react-bootstrap/Form';
import RichText from '../controls/RichText';
import NeutralToggle from '../controls/NeutralToggle';
import { useForceUpdate, getRawText } from '../util';
import { deepMap, hydrate } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import { Range } from 'slate';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
const DEBUG = false;
export default function TaskPassageClick(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const [collapsed, setCollapsed] = React.useState(true);
  const setPathValue = (path, fun) => {
    DEBUG && console.log("setPathValue", path);
    let activeClickParent = path.slice(0, -1).reduce((p, c) => p.children[c], {
      children: props.data.children
    });
    let activeClickParentChildren = deepMap(JSON.parse(JSON.stringify(activeClickParent.children)), hydrate);
    let activeClick = activeClickParentChildren[path[path.length - 1]];
    fun(activeClick);
    activeClickParent.children = activeClickParentChildren;
  };
  const editorRef = /*#__PURE__*/React.createRef();
  const customEditorRef = /*#__PURE__*/React.createRef();
  let count = 0;
  function renderChildTab(v, k) {
    var _v$children;
    let path = this.slice();
    path.push(k);
    if (v.tagName === "TaskPassageClick.Click") {
      var _v$props, _v$props2, _v$props3, _v$props4;
      count++;
      return /*#__PURE__*/React.createElement(TabContextReporter, {
        key: k,
        index: String(count),
        title: "Response: " + count
      }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Response:")), /*#__PURE__*/React.createElement("div", null, getRawText(v))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Feedback:")), /*#__PURE__*/React.createElement(RichText, {
        key: "PC-richtext-" + k,
        value: (_v$props = v.props) === null || _v$props === void 0 ? void 0 : _v$props.feedback,
        onChange: v => {
          DEBUG && console.log("First onChange", path);
          setPathValue(path, activeClick => {
            activeClick.props.feedback = v;
            DEBUG && console.log("AFTER", activeClick);
          });
          //forceUpdate()
          props.onChanged();
        }
      }), /*#__PURE__*/React.createElement(FormValidityReporter, {
        valid: ((_v$props2 = v.props) === null || _v$props2 === void 0 ? void 0 : _v$props2.feedback) && getRawText((_v$props3 = v.props) === null || _v$props3 === void 0 ? void 0 : _v$props3.feedback).length > 0
      }, "Feedback is required.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        style: {
          marginRight: "5px"
        }
      }, /*#__PURE__*/React.createElement("b", null, "Correct:")), /*#__PURE__*/React.createElement(NeutralToggle, {
        optionTrue: "Correct",
        optionFalse: "Incorrect",
        value: (_v$props4 = v.props) === null || _v$props4 === void 0 ? void 0 : _v$props4.correct,
        onChange: v => {
          setPathValue(path, activeClick => {
            console.log("Changed to: ", activeClick, v);
            activeClick.props.correct = v;
          });
          forceUpdate();
          props.onChanged();
        }
      })));
    } else if ((_v$children = v.children) !== null && _v$children !== void 0 && _v$children.map) {
      return v.children.map(renderChildTab, path);
    }
  }
  return /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Prompt:"), " ", /*#__PURE__*/React.createElement("i", null, "Instructions for the user.")), /*#__PURE__*/React.createElement(RichText, {
    inlineOnly: true,
    value: dataProps.prompt,
    onChange: v => {
      dataProps.prompt = v;
      forceUpdate();
      props.onChanged();
    },
    inlineOnly: true
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Passage:"), " ", /*#__PURE__*/React.createElement("i", null, "Use the brush to mark up the text.")), /*#__PURE__*/React.createElement(RichText, {
    value: props.data.children,
    onChange: v => {
      props.data.children = v;
      //forceUpdate()
      props.onChanged();
    },
    toolbar: [{
      type: 'Component',
      tagName: "TaskPassageClick.Click",
      title: 'Passage Click',
      icon: 'brush',
      variant: 'primary',
      onSelect: console.log
    }],
    editorRef: editorRef,
    customEditorRef: customEditorRef,
    onSelect: e => {
      let editor = editorRef.current;
      let CustomEditor = customEditorRef.current;
      let c = Range.isCollapsed(editor.selection);
      if (c !== collapsed) {
        setCollapsed(c);
      }
      const result = CustomEditor.getActiveTag(editor, "TaskPassageClick.Click");
      if (!!result) {
        const [node, path] = result;
      }
    }
  })))), props.data.children && props.data.children.map(renderChildTab, []));
}